import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookNumericFormatInputWrapper } from 'src/components/CookbookNumericFormatInputWrapper/CookbookNumericFormatInputWrapper';
import { getFeeValidation } from 'src/components/enterprise/features/Corporate/components/Form/utils/feeValidation.utils';

export interface CateringServiceFeeControlProps {
  name: string;
  id: string;
}

export function CateringServiceFeeControl({
  name,
  id,
}: CateringServiceFeeControlProps): JSX.Element {
  const { errors, control } = useFormContext();
  const label = 'Catering service fee';
  const validate = getFeeValidation({
    label,
  });

  return (
    <CookbookNumericFormatInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      inputSize="medium"
      blockWidth
      label="Catering Service Fee *"
      placeholder="e.g. 5"
      suffixDecorator="%"
      maxFractionalDigits={2}
      rules={{
        required: `${label} is required`,
        validate,
      }}
    />
  );
}
